import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import LoginService from '@/services/LoginService.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pdf: '',
    notFound: true,
    viewer: false,
    pageNum: 1,
    pages: 0,
    percentage: 100
  },
  mutations: {
    SET_AUTHORIZATION (state, userData) {
      window.localStorage.setItem('x-auth-token', `Bearer ${
        userData
      }`)

      LoginService.updateToken()

      axios.defaults.headers.common['x-auth-token'] = `Bearer ${
        userData
      }`
    },
    SET_PDF_DATA (state, pdf) {
      state.pdf = pdf.data
      state.notFound = false
    },
    SET_NOT_FOUND (state, status) {
      state.notFound = status
    },
    SET_VIEWER_STATUS (state, status) {
      state.viewer = status
    },
    SET_PAGES (state, pages) {
      state.pages = pages
    },
    SET_PAGE_NUM (state, num) {
      state.pageNum = num
    },
    SET_PERCENTAGE (state, value) {
      state.percentage = value
    }
  },
  actions: {
    async getUserReport ({ commit }, hash) {
      return LoginService.getPDF(hash)
        .then(({ data }) => {
          commit('SET_PDF_DATA', data)
        })
        .catch(() => {
          commit('SET_NOT_FOUND', true)
        })
    }
  },
  getters: {
    getPDF: state => {
      return state.pdf
    },
    getNotFound: state => {
      return state.notFound
    },
    getViewer: state => {
      return state.viewer
    },
    getPages: state => {
      return state.pages
    },
    getPageNum: state => {
      return state.pageNum
    },
    getPercentage: state => {
      return state.percentage
    }
  }
})
